// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";

const http = new AxiosAdapter();

export const changePasswordService = async (data: any) => {
    try {
        const endpoint = (data?.employeeId || data?.userId)
            ? '/v1/users/change-password-employee'
            : '/v1/users/change-password';
        return await http.postLogin<any>(endpoint, data); 
    } catch (error) {
        console.log('changePasswordService error: ', error);
    }
};

export const getApplicationsService = async () => {
    try {
        return await http.get<any>('/v1/users/get-applications');
    } catch (error) {
        console.log('getApplicationsService error: ', error);
    }
};
